export class AppValidator {

    notEmpty(control: any) {
        try {
            if (control.value.toString().trim() == '')
                return {"empty": true};
            return null;
        } catch (ex) {
            return {"empty": true};
        }
    }

    isFloat(control: any) {
        try {
            var n = control.value.toString().replace(",", ".");
            var floatRegex = /^-?\d+(?:[.,]\d*?)?$/;
            if (!floatRegex.test(n))
                return {"invalidFloat": true};
            return null;
        } catch (ex) {
            return {"invalidFloat": true};
        }
    }

    isNotZero(control: any) {
        try {
            var n = control.value.toString().replace(",", ".");
            var floatRegex = /^-?\d+(?:[.,]\d*?)?$/;
            if (!floatRegex.test(n))
                return {"isZero": true};
            else {
                if (parseFloat(n) == 0) return {"isZero": true};
            }
            return null;
        } catch (ex) {
            return {"isZero": true};
        }
    }

    isObject(control: any) {
        try {
            if (control.value.value != null)
                return null;
            return {"invalidObject": true};
        } catch (ex) {
            return {"invalidObject": true};
        }
    }

    isEmail(control: any) {
        try {
            var sQtext = '[^\\x0d\\x22\\x5c\\x80-\\xff]';
            var sDtext = '[^\\x0d\\x5b-\\x5d\\x80-\\xff]';
            var sAtom = '[^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+';
            var sQuotedPair = '\\x5c[\\x00-\\x7f]';
            var sDomainLiteral = '\\x5b(' + sDtext + '|' + sQuotedPair + ')*\\x5d';
            var sQuotedString = '\\x22(' + sQtext + '|' + sQuotedPair + ')*\\x22';
            var sDomain_ref = sAtom;
            var sSubDomain = '(' + sDomain_ref + '|' + sDomainLiteral + ')';
            var sWord = '(' + sAtom + '|' + sQuotedString + ')';
            var sDomain = sSubDomain + '(\\x2e' + sSubDomain + ')*';
            var sLocalPart = sWord + '(\\x2e' + sWord + ')*';
            var sAddrSpec = sLocalPart + '\\x40' + sDomain; // complete RFC822 email address spec
            var sValidEmail = '^' + sAddrSpec + '$'; // as whole string

            var reValidEmail = new RegExp(sValidEmail);

            if (reValidEmail.test(control.value))
                return null;
            return {"isEmail": true};
        } catch (ex) {
            return {"isEmail": true};
        }
    }

    isInt(control: any) {
        try {
            var n = control.value.toString().replace(",", ".");
            var intRegex = /^-?\d+\.?\d*$/;
            if (!intRegex.test(n))
                return {"invalidInt": true};
            return null;
        } catch (ex) {
            return {"invalidInt": true};
        }
    }

    intlIsValidPhoneNumber(control: any) {
        if (control.value.trim() == '') {
            return null;
        }
        let controlName = '';
        Object.keys(control.parent.controls).forEach((key: string) => {
            if (control.parent.controls[key] == control) {
                controlName = key;
            }
        });
        if (controlName == '') {
            return {"invalidPhoneNumber": true};
        }
        try {
            if (!$('#' + controlName).intlTelInput("isValidNumber")) {
                return {"invalidPhoneNumber": true};
            }
            return null;
        } catch (ex) {
            return {"invalidPhoneNumber": true};
        }
    }

    // TODO: kivenni majd...
    tmpIsFloat(value) {
        try {
            var n = value.toString().replace(",", ".");
            var floatRegex = /^-?\d+(?:[.,]\d*?)?$/;
            if (!floatRegex.test(n))
                return false;
            return true;
        } catch (ex) {
            return false;
        }
    }

}
